var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "54px",
    height: "57px",
    viewBox: "0 0 54 57",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-784.000000, -189.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(786.000000, 191.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#D8D8D8",
    opacity: 0.293410528,
    cx: 25,
    cy: 53.5,
    rx: 25,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 0.000000)",
    stroke: "#CBCBCB",
    strokeLinecap: "square",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder-16"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "6.3559322 10.63633 6.3559322 0.4254532 16.5254237 0.4254532 21.6101695 5.5308916 43.6440678 5.5308916 43.6440678 10.63633"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "43.6440678 44.672586 6.3559322 44.672586 0.423728814 15.7417684 49.5762712 15.7417684"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "sad",
    opacity: 0.285132999,
    transform: "translate(17.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#888888",
    strokeLinecap: "square",
    cx: 1.5,
    cy: 1.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#888888",
    strokeLinecap: "square",
    cx: 15.5,
    cy: 1.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,9 C5.03072989,7.14372262 6.93693427,6 9,6 C11.0630657,6 12.9692701,7.14372262 14,9",
    id: "Path",
    stroke: "#888888",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#888888",
    fillRule: "nonzero",
    cx: 1.5,
    cy: 1.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#888888",
    fillRule: "nonzero",
    cx: 15.5,
    cy: 1.5,
    r: 1.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFolder);
export default __webpack_public_path__ + "static/media/empty-folder.48927e311c3b64db5ff0020b2dbe8711.svg";
export { ForwardRef as ReactComponent };